<template>
    <div>
        <!-- Nav tabs -->
        <ul class="nav nav-tabs details-tabs" role="tablist">
            <li role="presentation" class="active">
                <a href="#overview" aria-controls="home" role="tab" data-toggle="tab">产品概览</a>
            </li>
            <li role="presentation">
                <a href="#details" aria-controls="profile" role="tab" data-toggle="tab">产品规格</a>
            </li>
        </ul>
        <!-- Tab panes -->
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="overview">
                <img src="../assets/img/detail/fkw/1.jpg" width="100%" />
				<img src="../assets/img/detail/fkw/2.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/3.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/4.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/5.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/6.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/7.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/8.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/9.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/10.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/11.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/12.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/13.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/14.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/15.jpg" width="100%"/>
				<img src="../assets/img/detail/fkw/16.jpg" width="100%"/>
            </div>
            <div role="tabpanel" class="tab-pane" id="details">
                <table class="table table-style table-bordered" cellspacing="" cellpadding="">
                    <thead>
                    <tr>
                        <th colspan="17">平纹网规格网参数表</th>
                    </tr>
                    <tr>
                        <th rowspan="2">丝径(mm)</th>
                        <th colspan="2">2目</th>
						<th colspan="2">2.5目</th>
						<th colspan="2">3目</th>
						<th colspan="2">3.5目</th>
						<th colspan="2">4目</th>
						<th colspan="2">4.5目</th>
						<th colspan="2">5目</th>
						<th colspan="2">5.5目</th>
                    </tr>
					<tr>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
					</tr>
                    </thead>
                    <tbody>
						<tr>
							<td align="center">2.00</td>
							<td align="center">10.700</td>
							<td align="center">70.98</td>
							<td align="center">8.160</td>
							<td align="center">64.5</td>
							<td align="center">6.466</td>
							<td align="center">58.33</td>
							<td align="center">5.257</td>
							<td align="center">52.47</td>
							<td align="center">4.350</td>
							<td align="center">46.92</td>
							<td align="center">3.644</td>
							<td align="center">41.69</td>
							<td align="center">3.080</td>
							<td align="center">36.76</td>
							<td align="center">2.618</td>
							<td align="center">32.14</td>
						</tr>
						<tr>
							<td align="center">1.80</td>
							<td align="center">10.900</td>
							<td align="center">73.66</td>
							<td align="center">8.360</td>
							<td align="center">67.7</td>
							<td align="center">6.666</td>
							<td align="center">61.99</td>
							<td align="center">5.457</td>
							<td align="center">56.54</td>
							<td align="center">4.550</td>
							<td align="center">51.34</td>
							<td align="center">3.844</td>
							<td align="center">46.39</td>
							<td align="center">3.280</td>
							<td align="center">41.69</td>
							<td align="center">2.818</td>
							<td align="center">37.24</td>
						</tr>
						<tr>
							<td align="center">1.60</td>
							<td align="center">11.100</td>
							<td align="center">76.39</td>
							<td align="center">8.560</td>
							<td align="center">70.98</td>
							<td align="center">6.866</td>
							<td align="center">65.77</td>
							<td align="center">5.657</td>
							<td align="center">60.76</td>
							<td align="center">4.750</td>
							<td align="center">55.95</td>
							<td align="center">4.044</td>
							<td align="center">51.34</td>
							<td align="center">3.480</td>
							<td align="center">46.93</td>
							<td align="center">3.018</td>
							<td align="center">42.71</td>
						</tr>
						<tr>
							<td align="center">1.40</td>
							<td align="center">11.300</td>
							<td align="center">79.16</td>
							<td align="center">8.760</td>
							<td align="center">74.33</td>
							<td align="center">7.066</td>
							<td align="center">69.66</td>
							<td align="center">5.857</td>
							<td align="center">65.13</td>
							<td align="center">4.950</td>
							<td align="center">60.76</td>
							<td align="center">4.244</td>
							<td align="center">56.55</td>
							<td align="center">3.680</td>
							<td align="center">52.48</td>
							<td align="center">3.218</td>
							<td align="center">48.56</td>
						</tr>
						<tr>
							<td align="center">1.20</td>
							<td align="center">11.500</td>
							<td align="center">81.99</td>
							<td align="center">8.960</td>
							<td align="center">77.77</td>
							<td align="center">7.266</td>
							<td align="center">73.66</td>
							<td align="center">6.057</td>
							<td align="center">69.86</td>
							<td align="center">5.150</td>
							<td align="center">65.77</td>
							<td align="center">4.444</td>
							<td align="center">62.00</td>
							<td align="center">3.880</td>
							<td align="center">58.34</td>
							<td align="center">3.418</td>
							<td align="center">54.78</td>
						</tr>
						<tr>
							<td align="center">1.00</td>
							<td align="center">11.700</td>
							<td align="center">84.87</td>
							<td align="center">9.160</td>
							<td align="center">81.28</td>
							<td align="center">7.466</td>
							<td align="center">77.77</td>
							<td align="center">6.257</td>
							<td align="center">74.33</td>
							<td align="center">5.350</td>
							<td align="center">70.98</td>
							<td align="center">4.644</td>
							<td align="center">67.71</td>
							<td align="center">4.080</td>
							<td align="center">64.50</td>
							<td align="center">3.618</td>
							<td align="center">61.38</td>
						</tr>
						<tr>
							<td align="center">0.90</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">5.450</td>
							<td align="center">73.66</td>
							<td align="center">4.744</td>
							<td align="center">70.65</td>
							<td align="center">4.180</td>
							<td align="center">67.71</td>
							<td align="center">3.718</td>
							<td align="center">64.82</td>
						</tr>
						<tr>
							<td align="center">0.80</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">5.550</td>
							<td align="center">76.39</td>
							<td align="center">4.844</td>
							<td align="center">73.66</td>
							<td align="center">4.280</td>
							<td align="center">70.98</td>
							<td align="center">3.818</td>
							<td align="center">68.35</td>
						</tr>
						<tr>
							<td align="center">0.70</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">4.380</td>
							<td align="center">74.34</td>
							<td align="center">3.918</td>
							<td align="center">71.98</td>
						</tr>
						<tr>
							<td align="center">0.65</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">4.430</td>
							<td align="center">76.05</td>
							<td align="center">3.968</td>
							<td align="center">73.83</td>
						</tr>
						<tr>
							<td align="center">0.62</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">4.460</td>
							<td align="center">77.08</td>
							<td align="center">3.998</td>
							<td align="center">74.95</td>
						</tr>
						<tr>
							<td align="center">0.60</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">4.480</td>
							<td align="center">77.77</td>
							<td align="center">4.018</td>
							<td align="center">75.70</td>
						</tr>
						<tr>
							<td align="center">0.55</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">4.530</td>
							<td align="center">79.52</td>
							<td align="center">4.068</td>
							<td align="center">77.60</td>
						</tr>
						<tr>
							<td align="center">0.50</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">4.580</td>
							<td align="center">81.28</td>
							<td align="center">4.118</td>
							<td align="center">79.52</td>
						</tr>
                    </tbody>
                </table>
				<table class="table table-style table-bordered" cellspacing="" cellpadding="">
				    <thead>
				    <tr>
				        <th rowspan="2">丝径(mm)</th>
						<th colspan="2">6目</th>
						<th colspan="2">7目</th>
						<th colspan="2">8目</th>
						<th colspan="2">9目</th>
						<th colspan="2">10目</th>
						<th colspan="2">11目</th>
						<th colspan="2">12目</th>
						<th colspan="2">14目</th>
				    </tr>
					<tr>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
					</tr>
				    </thead>
				    <tbody>
						<tr>
							<td align="center">1.60</td>
							<td align="center">2.633</td>
							<td align="center">38.69</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">1.40</td>
							<td align="center">2.833</td>
							<td align="center">44.80</td>
							<td align="center">2.229</td>
							<td align="center">37.72</td>
							<td align="center">1.775</td>
							<td align="center">31.25</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">1.20</td>
							<td align="center">3.033</td>
							<td align="center">51.34</td>
							<td align="center">2.429</td>
							<td align="center">44.80</td>
							<td align="center">1.975</td>
							<td align="center">38.69</td>
							<td align="center">1.622</td>
							<td align="center">33.04</td>
							<td align="center">1.340</td>
							<td align="center">27.83</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">1.00</td>
							<td align="center">3.233</td>
							<td align="center">58.34</td>
							<td align="center">2.629</td>
							<td align="center">52.48</td>
							<td align="center">2.175</td>
							<td align="center">46.93</td>
							<td align="center">1.822</td>
							<td align="center">41.69</td>
							<td align="center">1.540</td>
							<td align="center">36.76</td>
							<td align="center">1.309</td>
							<td align="center">32.14</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.90</td>
							<td align="center">3.333</td>
							<td align="center">62.00</td>
							<td align="center">2.729</td>
							<td align="center">56.55</td>
							<td align="center">2.275</td>
							<td align="center">51.34</td>
							<td align="center">1.922</td>
							<td align="center">46.39</td>
							<td align="center">1.640</td>
							<td align="center">41.69</td>
							<td align="center">1.409</td>
							<td align="center">37.24</td>
							<td align="center">1.217</td>
							<td align="center">33.04</td>
							<td align="center">0.914</td>
							<td align="center">25.4</td>
						</tr>
						<tr>
							<td align="center">0.80</td>
							<td align="center">3.433</td>
							<td align="center">65.78</td>
							<td align="center">2.829</td>
							<td align="center">60.77</td>
							<td align="center">2.375</td>
							<td align="center">55.96</td>
							<td align="center">2.022</td>
							<td align="center">51.34</td>
							<td align="center">1.740</td>
							<td align="center">46.93</td>
							<td align="center">1.509</td>
							<td align="center">42.71</td>
							<td align="center">1.317</td>
							<td align="center">38.69</td>
							<td align="center">1.014</td>
							<td align="center">31.25</td>
						</tr>
						<tr>
							<td align="center">0.70</td>
							<td align="center">3.533</td>
							<td align="center">69.66</td>
							<td align="center">2.929</td>
							<td align="center">66.14</td>
							<td align="center">2.475</td>
							<td align="center">60.77</td>
							<td align="center">2.122</td>
							<td align="center">56.55</td>
							<td align="center">1.840</td>
							<td align="center">52.48</td>
							<td align="center">1.609</td>
							<td align="center">48.56</td>
							<td align="center">1.417</td>
							<td align="center">44.80</td>
							<td align="center">1.114</td>
							<td align="center">37.72</td>
						</tr>
						<tr>
							<td align="center">0.65</td>
							<td align="center">3.583</td>
							<td align="center">71.65</td>
							<td align="center">2.979</td>
							<td align="center">67.38</td>
							<td align="center">2.525</td>
							<td align="center">63.25</td>
							<td align="center">2.172</td>
							<td align="center">59.24</td>
							<td align="center">1.890</td>
							<td align="center">55.37</td>
							<td align="center">1.659</td>
							<td align="center">51.82</td>
							<td align="center">1.467</td>
							<td align="center">48.01</td>
							<td align="center">1.164</td>
							<td align="center">41.18</td>
						</tr>
						<tr>
							<td align="center">0.62</td>
							<td align="center">3.613</td>
							<td align="center">72.85</td>
							<td align="center">3.009</td>
							<td align="center">68.75</td>
							<td align="center">2.555</td>
							<td align="center">64.76</td>
							<td align="center">2.202</td>
							<td align="center">60.89</td>
							<td align="center">1.920</td>
							<td align="center">57.14</td>
							<td align="center">1.689</td>
							<td align="center">53.51</td>
							<td align="center">1.497</td>
							<td align="center">50.00</td>
							<td align="center">1.194</td>
							<td align="center">43.33</td>
						</tr>
						<tr>
							<td align="center">0.60</td>
							<td align="center">3.633</td>
							<td align="center">73.66</td>
							<td align="center">3.029</td>
							<td align="center">69.66</td>
							<td align="center">2.575</td>
							<td align="center">65.78</td>
							<td align="center">2.222</td>
							<td align="center">62.00</td>
							<td align="center">1.940</td>
							<td align="center">58.34</td>
							<td align="center">1.709</td>
							<td align="center">54.78</td>
							<td align="center">1.517</td>
							<td align="center">51.34</td>
							<td align="center">1.214</td>
							<td align="center">44.80</td>
						</tr>
						<tr>
							<td align="center">0.55</td>
							<td align="center">3.683</td>
							<td align="center">75.70</td>
							<td align="center">3.079</td>
							<td align="center">71.98</td>
							<td align="center">2.625</td>
							<td align="center">68.36</td>
							<td align="center">2.272</td>
							<td align="center">64.82</td>
							<td align="center">1.990</td>
							<td align="center">61.38</td>
							<td align="center">1.759</td>
							<td align="center">58.04</td>
							<td align="center">1.567</td>
							<td align="center">54.78</td>
							<td align="center">1.264</td>
							<td align="center">48.56</td>
						</tr>
						<tr>
							<td align="center">0.50</td>
							<td align="center">3.733</td>
							<td align="center">77.77</td>
							<td align="center">3.129</td>
							<td align="center">74.34</td>
							<td align="center">2.675</td>
							<td align="center">70.98</td>
							<td align="center">2.322</td>
							<td align="center">67.71</td>
							<td align="center">2.040</td>
							<td align="center">64.50</td>
							<td align="center">1.809</td>
							<td align="center">61.38</td>
							<td align="center">1.617</td>
							<td align="center">58.34</td>
							<td align="center">1.314</td>
							<td align="center">52.48</td>
						</tr>
						<tr>
							<td align="center">0.45</td>
							<td align="center">3.783</td>
							<td align="center">79.87</td>
							<td align="center">3.179</td>
							<td align="center">76.73</td>
							<td align="center">2.725</td>
							<td align="center">73.66</td>
							<td align="center">2.372</td>
							<td align="center">70.65</td>
							<td align="center">2.090</td>
							<td align="center">67.71</td>
							<td align="center">1.859</td>
							<td align="center">64.82</td>
							<td align="center">1.867</td>
							<td align="center">62.00</td>
							<td align="center">1.364</td>
							<td align="center">56.55</td>
						</tr>
						<tr>
							<td align="center">0.40</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">3.229</td>
							<td align="center">79.17</td>
							<td align="center">2.775</td>
							<td align="center">76.39</td>
							<td align="center">2.422</td>
							<td align="center">73.66</td>
							<td align="center">2.140</td>
							<td align="center">70.98</td>
							<td align="center">1.909</td>
							<td align="center">68.36</td>
							<td align="center">1.717</td>
							<td align="center">65.78</td>
							<td align="center">1.414</td>
							<td align="center">60.77</td>
						</tr>
						<tr>
							<td align="center">0.35</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">2.825</td>
							<td align="center">79.17</td>
							<td align="center">2.472</td>
							<td align="center">76.73</td>
							<td align="center">2.190</td>
							<td align="center">74.34</td>
							<td align="center">1.959</td>
							<td align="center">71.98</td>
							<td align="center">1.767</td>
							<td align="center">69.66</td>
							<td align="center">1.464</td>
							<td align="center">65.14</td>
						</tr>
						<tr>
							<td align="center">0.32</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">2.855</td>
							<td align="center">80.86</td>
							<td align="center">2.502</td>
							<td align="center">78.61</td>
							<td align="center">2.220</td>
							<td align="center">76.39</td>
							<td align="center">1.989</td>
							<td align="center">74.20</td>
							<td align="center">1.797</td>
							<td align="center">72.06</td>
							<td align="center">1.494</td>
							<td align="center">67.84</td>
						</tr>
						<tr>
							<td align="center">0.30</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">2.240</td>
							<td align="center">77.77</td>
							<td align="center">2.009</td>
							<td align="center">75.70</td>
							<td align="center">1.817</td>
							<td align="center">73.66</td>
							<td align="center">1.514</td>
							<td align="center">69.66</td>
						</tr>
						<tr>
							<td align="center">0.29</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">2.250</td>
							<td align="center">78.47</td>
							<td align="center">2.019</td>
							<td align="center">76.46</td>
							<td align="center">1.827</td>
							<td align="center">74.48</td>
							<td align="center">1.524</td>
							<td align="center">70.59</td>
						</tr>
						<tr>
							<td align="center">0.28</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">2.260</td>
							<td align="center">79.17</td>
							<td align="center">2.029</td>
							<td align="center">77.22</td>
							<td align="center">1.837</td>
							<td align="center">75.29</td>
							<td align="center">1.534</td>
							<td align="center">71.52</td>
						</tr>
						<tr>
							<td align="center">0.26</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">2.280</td>
							<td align="center">80.58</td>
							<td align="center">2.049</td>
							<td align="center">78.75</td>
							<td align="center">1.857</td>
							<td align="center">76.94</td>
							<td align="center">1.554</td>
							<td align="center">73.39</td>
						</tr>
						<tr>
							<td align="center">0.24</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">1.877</td>
							<td align="center">78.61</td>
							<td align="center">1.574</td>
							<td align="center">75.29</td>
						</tr>
						<tr>
							<td align="center">0.23</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">1.584</td>
							<td align="center">76.25</td>
						</tr>
						<tr>
							<td align="center">0.22</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">1.594</td>
							<td align="center">77.22</td>
						</tr>
				    </tbody>
				</table>
				<table class="table table-style table-bordered" cellspacing="" cellpadding="">
				    <thead>
				    <tr>
				        <th rowspan="2">丝径(mm)</th>
						<th colspan="2">16目</th>
						<th colspan="2">18目</th>
						<th colspan="2">20目</th>
						<th colspan="2">22目</th>
						<th colspan="2">24目</th>
						<th colspan="2">26目</th>
						<th colspan="2">28目</th>
						<th colspan="2">30目</th>
				    </tr>
					<tr>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
					</tr>
				    </thead>
				    <tbody>
						<tr>
							<td align="center">0.70</td>
							<td align="center">0.888</td>
							<td align="center">31.25</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.65</td>
							<td align="center">0.938</td>
							<td align="center">34.88</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.62</td>
							<td align="center">0.968</td>
							<td align="center">37.14</td>
							<td align="center">0.791</td>
							<td align="center">31.43</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.60</td>
							<td align="center">0.988</td>
							<td align="center">38.69</td>
							<td align="center">0.811</td>
							<td align="center">33.04</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.55</td>
							<td align="center">1.038</td>
							<td align="center">42.71</td>
							<td align="center">0.861</td>
							<td align="center">37.24</td>
							<td align="center">0.720</td>
							<td align="center">32.14</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.50</td>
							<td align="center">1.088</td>
							<td align="center">46.93</td>
							<td align="center">0.911</td>
							<td align="center">41.69</td>
							<td align="center">0.770</td>
							<td align="center">36.76</td>
							<td align="center">0.656</td>
							<td align="center">32.14</td>
							<td align="center">0.558</td>
							<td align="center">27.83</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.45</td>
							<td align="center">1.138</td>
							<td align="center">51.34</td>
							<td align="center">0.961</td>
							<td align="center">46.39</td>
							<td align="center">0.820</td>
							<td align="center">41.69</td>
							<td align="center">0.706</td>
							<td align="center">37.24</td>
							<td align="center">0.608</td>
							<td align="center">33.04</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.40</td>
							<td align="center">1.183</td>
							<td align="center">55.96</td>
							<td align="center">1.011</td>
							<td align="center">51.34</td>
							<td align="center">0.870</td>
							<td align="center">46.93</td>
							<td align="center">0.756</td>
							<td align="center">42.71</td>
							<td align="center">0.658</td>
							<td align="center">38.69</td>
							<td align="center">0.577</td>
							<td align="center">34.88</td>
							<td align="center">0.507</td>
							<td align="center">31.25</td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.35</td>
							<td align="center">1.238</td>
							<td align="center">60.77</td>
							<td align="center">1.061</td>
							<td align="center">56.55</td>
							<td align="center">0.920</td>
							<td align="center">52.48</td>
							<td align="center">0.806</td>
							<td align="center">48.56</td>
							<td align="center">0.708</td>
							<td align="center">44.80</td>
							<td align="center">0.627</td>
							<td align="center">41.18</td>
							<td align="center">0.557</td>
							<td align="center">37.72</td>
							<td align="center">0.497</td>
							<td align="center">34.41</td>
						</tr>
						<tr>
							<td align="center">0.32</td>
							<td align="center">1.268</td>
							<td align="center">63.75</td>
							<td align="center">1.091</td>
							<td align="center">59.79</td>
							<td align="center">0.950</td>
							<td align="center">55.96</td>
							<td align="center">0.835</td>
							<td align="center">52.25</td>
							<td align="center">0.738</td>
							<td align="center">48.67</td>
							<td align="center">0.657</td>
							<td align="center">45.22</td>
							<td align="center">0.587</td>
							<td align="center">41.89</td>
							<td align="center">0.527</td>
							<td align="center">38.69</td>
						</tr>
						<tr>
							<td align="center">0.30</td>
							<td align="center">1.288</td>
							<td align="center">65.78</td>
							<td align="center">1.111</td>
							<td align="center">62.00</td>
							<td align="center">0.970</td>
							<td align="center">58.34</td>
							<td align="center">0.856</td>
							<td align="center">54.78</td>
							<td align="center">0.758</td>
							<td align="center">51.34</td>
							<td align="center">0.677</td>
							<td align="center">48.01</td>
							<td align="center">0.607</td>
							<td align="center">44.80</td>
							<td align="center">0.547</td>
							<td align="center">41.69</td>
						</tr>
						<tr>
							<td align="center">0.29</td>
							<td align="center">1.298</td>
							<td align="center">66.80</td>
							<td align="center">1.121</td>
							<td align="center">63.12</td>
							<td align="center">0.980</td>
							<td align="center">59.54</td>
							<td align="center">0.865</td>
							<td align="center">56.07</td>
							<td align="center">0.768</td>
							<td align="center">52.71</td>
							<td align="center">0.687</td>
							<td align="center">49.44</td>
							<td align="center">0.617</td>
							<td align="center">46.28</td>
							<td align="center">0.557</td>
							<td align="center">43.23</td>
						</tr>
						<tr>
							<td align="center">0.28</td>
							<td align="center">1.308</td>
							<td align="center">67.84</td>
							<td align="center">1.131</td>
							<td align="center">64.25</td>
							<td align="center">0.990</td>
							<td align="center">60.77</td>
							<td align="center">0.875</td>
							<td align="center">57.38</td>
							<td align="center">0.778</td>
							<td align="center">54.09</td>
							<td align="center">0.697</td>
							<td align="center">50.89</td>
							<td align="center">0.627</td>
							<td align="center">47.79</td>
							<td align="center">0.567</td>
							<td align="center">44.8</td>
						</tr>
						<tr>
							<td align="center">0.26</td>
							<td align="center">1.328</td>
							<td align="center">69.93</td>
							<td align="center">1.151</td>
							<td align="center">66.54</td>
							<td align="center">1.010</td>
							<td align="center">63.25</td>
							<td align="center">0.896</td>
							<td align="center">60.03</td>
							<td align="center">0.798</td>
							<td align="center">56.9</td>
							<td align="center">0.717</td>
							<td align="center">53.85</td>
							<td align="center">0.647</td>
							<td align="center">50.89</td>
							<td align="center">0.587</td>
							<td align="center">48.01</td>
						</tr>
						<tr>
							<td align="center">0.24</td>
							<td align="center">1.348</td>
							<td align="center">72.05</td>
							<td align="center">1.171</td>
							<td align="center">68.88</td>
							<td align="center">1.030</td>
							<td align="center">65.78</td>
							<td align="center">0.915</td>
							<td align="center">62.75</td>
							<td align="center">0.818</td>
							<td align="center">59.79</td>
							<td align="center">0.737</td>
							<td align="center">56.9</td>
							<td align="center">0.667</td>
							<td align="center">54.09</td>
							<td align="center">0.607</td>
							<td align="center">51.34</td>
						</tr>
						<tr>
							<td align="center">0.23</td>
							<td align="center">1.358</td>
							<td align="center">73.12</td>
							<td align="center">1.181</td>
							<td align="center">70.06</td>
							<td align="center">1.040</td>
							<td align="center">67.06</td>
							<td align="center">0.925</td>
							<td align="center">64.13</td>
							<td align="center">0.828</td>
							<td align="center">61.26</td>
							<td align="center">0.747</td>
							<td align="center">58.46</td>
							<td align="center">0.677</td>
							<td align="center">55.72</td>
							<td align="center">0.617</td>
							<td align="center">53.05</td>
						</tr>
						<tr>
							<td align="center">0.22</td>
							<td align="center">1.368</td>
							<td align="center">74.2</td>
							<td align="center">1.191</td>
							<td align="center">71.25</td>
							<td align="center">1.050</td>
							<td align="center">68.36</td>
							<td align="center">0.935</td>
							<td align="center">65.52</td>
							<td align="center">0.838</td>
							<td align="center">62.75</td>
							<td align="center">0.757</td>
							<td align="center">60.03</td>
							<td align="center">0.687</td>
							<td align="center">57.38</td>
							<td align="center">0.627</td>
							<td align="center">54.78</td>
						</tr>
						<tr>
							<td align="center">0.20</td>
							<td align="center">1.388</td>
							<td align="center">76.39</td>
							<td align="center">1.211</td>
							<td align="center">73.66</td>
							<td align="center">1.070</td>
							<td align="center">70.98</td>
							<td align="center">0.956</td>
							<td align="center">68.38</td>
							<td align="center">0.858</td>
							<td align="center">65.78</td>
							<td align="center">0.777</td>
							<td align="center">63.25</td>
							<td align="center">0.707</td>
							<td align="center">60.77</td>
							<td align="center">0.647</td>
							<td align="center">58.34</td>
						</tr>
						<tr>
							<td align="center">0.18</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">1.090</td>
							<td align="center">73.66</td>
							<td align="center">0.975</td>
							<td align="center">71.25</td>
							<td align="center">0.878</td>
							<td align="center">68.88</td>
							<td align="center">0.797</td>
							<td align="center">66.54</td>
							<td align="center">0.727</td>
							<td align="center">64.25</td>
							<td align="center">0.667</td>
							<td align="center">62.00</td>
						</tr>
						<tr>
							<td align="center">0.16</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.747</td>
							<td align="center">67.84</td>
							<td align="center">0.687</td>
							<td align="center">65.78</td>
						</tr>
						<tr>
							<td align="center">0.15</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.757</td>
							<td align="center">69.66</td>
							<td align="center">0.697</td>
							<td align="center">67.71</td>
						</tr>
				    </tbody>
				</table>
				<table class="table table-style table-bordered" cellspacing="" cellpadding="">
				    <thead>
				    <tr>
				        <th rowspan="2">丝径(mm)</th>
						<th colspan="2">32目</th>
						<th colspan="2">35目</th>
						<th colspan="2">36目</th>
						<th colspan="2">40目</th>
						<th colspan="2">45目</th>
						<th colspan="2">50目</th>
						<th colspan="2">55目</th>
						<th colspan="2">60目</th>
				    </tr>
					<tr>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
					</tr>
				    </thead>
				    <tbody>
						<tr>
							<td align="center">0.36</td>
							<td align="center">0.444</td>
							<td align="center">31.25</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.32</td>
							<td align="center">0.474</td>
							<td align="center">35.62</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.30</td>
							<td align="center">0.494</td>
							<td align="center">38.69</td>
							<td align="center">0.426</td>
							<td align="center">34.41</td>
							<td align="center">0.406</td>
							<td align="center">33.04</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.29</td>
							<td align="center">0.504</td>
							<td align="center">40.28</td>
							<td align="center">0.436</td>
							<td align="center">36.06</td>
							<td align="center">0.416</td>
							<td align="center">34.89</td>
							<td align="center">0.345</td>
							<td align="center">29.52</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.28</td>
							<td align="center">0.514</td>
							<td align="center">41.89</td>
							<td align="center">0.446</td>
							<td align="center">37.72</td>
							<td align="center">0.426</td>
							<td align="center">36.38</td>
							<td align="center">0.355</td>
							<td align="center">31.25</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.26</td>
							<td align="center">0.534</td>
							<td align="center">45.22</td>
							<td align="center">0.466</td>
							<td align="center">41.18</td>
							<td align="center">0.446</td>
							<td align="center">39.88</td>
							<td align="center">0.375</td>
							<td align="center">34.88</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.24</td>
							<td align="center">0.554</td>
							<td align="center">48.67</td>
							<td align="center">0.486</td>
							<td align="center">44.8</td>
							<td align="center">0.466</td>
							<td align="center">43.54</td>
							<td align="center">0.395</td>
							<td align="center">38.69</td>
							<td align="center">0.324</td>
							<td align="center">33.04</td>
							<td align="center">0.268</td>
							<td align="center">27.83</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.23</td>
							<td align="center">0.564</td>
							<td align="center">50.44</td>
							<td align="center">0.496</td>
							<td align="center">46.66</td>
							<td align="center">0.476</td>
							<td align="center">45.43</td>
							<td align="center">0.406</td>
							<td align="center">40.68</td>
							<td align="center">0.334</td>
							<td align="center">35.11</td>
							<td align="center">0.278</td>
							<td align="center">29.96</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.22</td>
							<td align="center">0.574</td>
							<td align="center">52.25</td>
							<td align="center">0.506</td>
							<td align="center">48.56</td>
							<td align="center">0.486</td>
							<td align="center">47.36</td>
							<td align="center">0.415</td>
							<td align="center">42.71</td>
							<td align="center">0.344</td>
							<td align="center">37.24</td>
							<td align="center">0.288</td>
							<td align="center">32.14</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.20</td>
							<td align="center">0.594</td>
							<td align="center">55.95</td>
							<td align="center">0.526</td>
							<td align="center">52.48</td>
							<td align="center">0.506</td>
							<td align="center">51.34</td>
							<td align="center">0.435</td>
							<td align="center">46.93</td>
							<td align="center">0.364</td>
							<td align="center">41.69</td>
							<td align="center">0.308</td>
							<td align="center">36.76</td>
							<td align="center">0.262</td>
							<td align="center">32.14</td>
							<td align="center">0.223</td>
							<td align="center">27.83</td>
						</tr>
						<tr>
							<td align="center">0.18</td>
							<td align="center">0.614</td>
							<td align="center">59.79</td>
							<td align="center">0.546</td>
							<td align="center">58.56</td>
							<td align="center">0.526</td>
							<td align="center">55.48</td>
							<td align="center">0.455</td>
							<td align="center">51.34</td>
							<td align="center">0.384</td>
							<td align="center">46.39</td>
							<td align="center">0.328</td>
							<td align="center">41.69</td>
							<td align="center">0.282</td>
							<td align="center">37.24</td>
							<td align="center">0.243</td>
							<td align="center">33.04</td>
						</tr>
						<tr>
							<td align="center">0.16</td>
							<td align="center">0.634</td>
							<td align="center">63.75</td>
							<td align="center">0.566</td>
							<td align="center">60.77</td>
							<td align="center">0.546</td>
							<td align="center">59.79</td>
							<td align="center">0.475</td>
							<td align="center">55.96</td>
							<td align="center">0.404</td>
							<td align="center">51.34</td>
							<td align="center">0.348</td>
							<td align="center">46.93</td>
							<td align="center">0.302</td>
							<td align="center">42.71</td>
							<td align="center">0.263</td>
							<td align="center">38.69</td>
						</tr>
						<tr>
							<td align="center">0.15</td>
							<td align="center">0.644</td>
							<td align="center">65.78</td>
							<td align="center">0.576</td>
							<td align="center">62.93</td>
							<td align="center">0.556</td>
							<td align="center">62</td>
							<td align="center">0.486</td>
							<td align="center">58.34</td>
							<td align="center">0.414</td>
							<td align="center">53.91</td>
							<td align="center">0.358</td>
							<td align="center">49.66</td>
							<td align="center">0.312</td>
							<td align="center">45.59</td>
							<td align="center">0.273</td>
							<td align="center">41.69</td>
						</tr>
						<tr>
							<td align="center">0.14</td>
							<td align="center">0.654</td>
							<td align="center">67.84</td>
							<td align="center">0.586</td>
							<td align="center">65.14</td>
							<td align="center">0.566</td>
							<td align="center">64.25</td>
							<td align="center">0.496</td>
							<td align="center">60.77</td>
							<td align="center">0.424</td>
							<td align="center">56.55</td>
							<td align="center">0.368</td>
							<td align="center">52.48</td>
							<td align="center">0.322</td>
							<td align="center">48.56</td>
							<td align="center">0.283</td>
							<td align="center">44.8</td>
						</tr>
						<tr>
							<td align="center">0.13</td>
							<td align="center">0.664</td>
							<td align="center">69.93</td>
							<td align="center">0.596</td>
							<td align="center">67.38</td>
							<td align="center">0.576</td>
							<td align="center">66.54</td>
							<td align="center">0.506</td>
							<td align="center">63.25</td>
							<td align="center">0.434</td>
							<td align="center">59.24</td>
							<td align="center">0.378</td>
							<td align="center">55.37</td>
							<td align="center">0.332</td>
							<td align="center">51.62</td>
							<td align="center">0.293</td>
							<td align="center">48.01</td>
						</tr>
						<tr>
							<td align="center">0.12</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.606</td>
							<td align="center">69.66</td>
							<td align="center">0.586</td>
							<td align="center">68.88</td>
							<td align="center">0.515</td>
							<td align="center">65.78</td>
							<td align="center">0.444</td>
							<td align="center">62.00</td>
							<td align="center">0.388</td>
							<td align="center">58.34</td>
							<td align="center">0.342</td>
							<td align="center">54.78</td>
							<td align="center">0.303</td>
							<td align="center">51.34</td>
						</tr>
						<tr>
							<td align="center">0.11</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.596</td>
							<td align="center">71.25</td>
							<td align="center">0.525</td>
							<td align="center">68.36</td>
							<td align="center">0.454</td>
							<td align="center">64.82</td>
							<td align="center">0.398</td>
							<td align="center">61.38</td>
							<td align="center">0.352</td>
							<td align="center">58.04</td>
							<td align="center">0.313</td>
							<td align="center">54.78</td>
						</tr>
						<tr>
							<td align="center">0.10</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.323</td>
							<td align="center">58.34</td>
						</tr>
				    </tbody>
				</table>
				<table class="table table-style table-bordered" cellspacing="" cellpadding="">
				    <thead>
				    <tr>
				        <th rowspan="2">丝径(mm)</th>
						<th colspan="2">65目</th>
						<th colspan="2">70目</th>
						<th colspan="2">80目</th>
						<th colspan="2">90目</th>
						<th colspan="2">100目</th>
						<th colspan="2">120目</th>
						<th colspan="2">130目</th>
						<th colspan="2">140目</th>
				    </tr>
					<tr>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
					</tr>
				    </thead>
				    <tbody>
						<tr>
							<td align="center">0.160</td>
							<td align="center">0.231</td>
							<td align="center">34.875</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.150</td>
							<td align="center">0.241</td>
							<td align="center">37.963</td>
							<td align="center">0.213</td>
							<td align="center">34.412</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.140</td>
							<td align="center">0.251</td>
							<td align="center">41.182</td>
							<td align="center">0.223</td>
							<td align="center">37.721</td>
							<td align="center">0.178</td>
							<td align="center">31.254</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.130</td>
							<td align="center">0.261</td>
							<td align="center">44.532</td>
							<td align="center">0.233</td>
							<td align="center">41.182</td>
							<td align="center">0.188</td>
							<td align="center">34.875</td>
							<td align="center">0.152</td>
							<td align="center">29.092</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.120</td>
							<td align="center">0.271</td>
							<td align="center">48.013</td>
							<td align="center">0.243</td>
							<td align="center">44.795</td>
							<td align="center">0.198</td>
							<td align="center">38.694</td>
							<td align="center">0.162</td>
							<td align="center">33.04</td>
							<td align="center">0.134</td>
							<td align="center">27.832</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.110</td>
							<td align="center">0.281</td>
							<td align="center">51.625</td>
							<td align="center">0.253</td>
							<td align="center">48.56</td>
							<td align="center">0.208</td>
							<td align="center">42.712</td>
							<td align="center">0.172</td>
							<td align="center">37.239</td>
							<td align="center">0.144</td>
							<td align="center">32.141</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.100</td>
							<td align="center">0.291</td>
							<td align="center">55.368</td>
							<td align="center">0.263</td>
							<td align="center">52.477</td>
							<td align="center">0.218</td>
							<td align="center">46.928</td>
							<td align="center">0.182</td>
							<td align="center">41.689</td>
							<td align="center">0.154</td>
							<td align="center">36.76</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.090</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.228</td>
							<td align="center">51.342</td>
							<td align="center">0.192</td>
							<td align="center">46.39</td>
							<td align="center">0.164</td>
							<td align="center">41.689</td>
							<td align="center">0.122</td>
							<td align="center">33.04</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.080</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.174</td>
							<td align="center">45.928</td>
							<td align="center">0.132</td>
							<td align="center">38.694</td>
							<td align="center">0.115</td>
							<td align="center">34.875</td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.070</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.142</td>
							<td align="center">44.796</td>
							<td align="center">0.125</td>
							<td align="center">41.182</td>
							<td align="center">0.111</td>
							<td align="center">37.721</td>
						</tr>
						<tr>
							<td align="center">0.065</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.130</td>
							<td align="center">44.532</td>
							<td align="center">0.116</td>
							<td align="center">41.182</td>
						</tr>
						<tr>
							<td align="center">0.060</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.121</td>
							<td align="center">44.796</td>
						</tr>
				    </tbody>
				</table>
				<table class="table table-style table-bordered" cellspacing="" cellpadding="">
				    <thead>
				    <tr>
				        <th rowspan="2">丝径(mm)</th>
						<th colspan="2">150目</th>
						<th colspan="2">160目</th>
						<th colspan="2">180目</th>
						<th colspan="2">200目</th>
						<th colspan="2">220目</th>
						<th colspan="2">250目</th>
						<th colspan="2">270目</th>
						<th colspan="2">300目</th>
				    </tr>
					<tr>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
					</tr>
				    </thead>
				    <tbody>
						<tr>
							<td align="center">0.070</td>
							<td align="center">0.099</td>
							<td align="center">34.412</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.065</td>
							<td align="center">0.104</td>
							<td align="center">37.963</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.060</td>
							<td align="center">0.109</td>
							<td align="center">41.689</td>
							<td align="center">0.099</td>
							<td align="center">38.694</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.067</td>
							<td align="center">27.832</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.055</td>
							<td align="center">0.114</td>
							<td align="center">45.589</td>
							<td align="center">0.104</td>
							<td align="center">42.712</td>
							<td align="center">0.086</td>
							<td align="center">32.239</td>
							<td align="center">0.072</td>
							<td align="center">32.141</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.050</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.109</td>
							<td align="center">46.928</td>
							<td align="center">0.091</td>
							<td align="center">41.689</td>
							<td align="center">0.077</td>
							<td align="center">36.760</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.052</td>
							<td align="center">25.794</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.045</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.096</td>
							<td align="center">46.39</td>
							<td align="center">0.082</td>
							<td align="center">41.689</td>
							<td align="center">0.070</td>
							<td align="center">37.239</td>
							<td align="center">0.057</td>
							<td align="center">31.035</td>
							<td align="center">0.049</td>
							<td align="center">27.212</td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.040</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.087</td>
							<td align="center">46.928</td>
							<td align="center">0.075</td>
							<td align="center">42.712</td>
							<td align="center">0.062</td>
							<td align="center">36.76</td>
							<td align="center">0.054</td>
							<td align="center">33.04</td>
							<td align="center">0.045</td>
							<td align="center">27.832</td>
						</tr>
						<tr>
							<td align="center">0.035</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.067</td>
							<td align="center">42.97</td>
							<td align="center">0.059</td>
							<td align="center">39.432</td>
							<td align="center">0.050</td>
							<td align="center">34.412</td>
						</tr>
						<tr>
							<td align="center">0.030</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.072</td>
							<td align="center">49.664</td>
							<td align="center">0.064</td>
							<td align="center">46.39</td>
							<td align="center">0.055</td>
							<td align="center">41.689</td>
						</tr>
						<tr>
							<td align="center">0.025</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.077</td>
							<td align="center">56.842</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
				    </tbody>
				</table>
				<table class="table table-style table-bordered" cellspacing="" cellpadding="">
				    <thead>
				    <tr>
				        <th rowspan="2">丝径(mm)</th>
						<th colspan="2">325目</th>
						<th colspan="2">350目</th>
						<th colspan="2">400目</th>
						<th colspan="2">500目</th>
						<th colspan="2">550目</th>
						<th colspan="2">600目</th>
						<th colspan="2">635目</th>
				    </tr>
					<tr>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
						<th>开孔(mm)</th>
						<th>开孔率(%)</th>
					</tr>
				    </thead>
				    <tbody>
						<tr>
							<td align="center">0.040</td>
							<td align="center">0.038</td>
							<td align="center">23.833</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.035</td>
							<td align="center">0.043</td>
							<td align="center">30.489</td>
							<td align="center">0.038</td>
							<td align="center">26.803</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.030</td>
							<td align="center">0.048</td>
							<td align="center">38.000</td>
							<td align="center">0.043</td>
							<td align="center">34.400</td>
							<td align="center">0.034</td>
							<td align="center">27.832</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.028</td>
							<td align="center">0.050</td>
							<td align="center">41.182</td>
							<td align="center">0.045</td>
							<td align="center">37.700</td>
							<td align="center">0.036</td>
							<td align="center">31.300</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.025</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.048</td>
							<td align="center">43.000</td>
							<td align="center">0.039</td>
							<td align="center">36.800</td>
							<td align="center">0.026</td>
							<td align="center">25.800</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.023</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.041</td>
							<td align="center">40.678</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.024</td>
							<td align="center">27.418</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
						</tr>
						<tr>
							<td align="center">0.020</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.022</td>
							<td align="center">27.832</td>
							<td align="center">0.020</td>
							<td align="center">25.000</td>
						</tr>
						<tr>
							<td align="center">0.018</td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center"></td>
							<td align="center">0.022</td>
							<td align="center">30.250</td>
						</tr>
				    </tbody>
				</table>
			</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>